'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tripleErr = exports.rmRefs = exports.indexFields = exports.predicateFilter = exports.hasPredicate = exports.refMatch = exports.fpGetRef = exports.pickTypeId = exports.REFS = exports.REF = undefined;

var _pick2 = require('lodash/fp/pick');

var _pick3 = _interopRequireDefault(_pick2);

var _omit2 = require('lodash/fp/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _set2 = require('lodash/set');

var _set3 = _interopRequireDefault(_set2);

var _reduce2 = require('lodash/reduce');

var _reduce3 = _interopRequireDefault(_reduce2);

var _rearg2 = require('lodash/rearg');

var _rearg3 = _interopRequireDefault(_rearg2);

var _pickBy2 = require('lodash/pickBy');

var _pickBy3 = _interopRequireDefault(_pickBy2);

var _partialRight2 = require('lodash/partialRight');

var _partialRight3 = _interopRequireDefault(_partialRight2);

var _now2 = require('lodash/now');

var _now3 = _interopRequireDefault(_now2);

var _isString2 = require('lodash/isString');

var _isString3 = _interopRequireDefault(_isString2);

var _isPlainObject2 = require('lodash/isPlainObject');

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _isArray2 = require('lodash/isArray');

var _isArray3 = _interopRequireDefault(_isArray2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _flow2 = require('lodash/flow');

var _flow3 = _interopRequireDefault(_flow2);

var _curry2 = require('lodash/curry');

var _curry3 = _interopRequireDefault(_curry2);

var _ary2 = require('lodash/ary');

var _ary3 = _interopRequireDefault(_ary2);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _indexFields;

exports.nextId = nextId;
exports.getKey = getKey;
exports.requireIdType = requireIdType;
exports.getPath = getPath;
exports.getRefPath = getRefPath;
exports.fullRefPath = fullRefPath;
exports.setRef = setRef;
exports.setRefs = setRefs;
exports.buildRef = buildRef;
exports.getRef = getRef;
exports.getRefs = getRefs;
exports.buildRefs = buildRefs;
exports.insertFields = insertFields;
exports.updateFields = updateFields;
exports.uniqEntity = uniqEntity;
exports.isSingle = isSingle;
exports.buildTriple = buildTriple;
exports.buildTripleDel = buildTripleDel;
exports.rangePath = rangePath;
exports.setRangeIncludes = setRangeIncludes;
exports.entityMatch = entityMatch;
exports.entityMatches = entityMatches;

var _capeLodash = require('cape-lodash');

var _lang = require('./lang');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var REF = exports.REF = '_ref';
var REFS = exports.REFS = '_refs'; // Generate a new random key. Probably unique.

function nextId() {
  return Math.random().toString(36).substr(6).substring(1, 9);
}

function getKey(_ref) {
  var type = _ref.type,
      id = _ref.id;
  return type + '_' + id;
} // @TODO Need a better name for this!


var pickTypeId = exports.pickTypeId = (0, _pick3.default)(['dateModified', 'id', 'type']);

function requireIdType(props) {
  var typeId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var doPick = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!(0, _isPlainObject3.default)(props)) throw new Error('Must pass an object.');

  if (!(0, _lang.isValidType)(props.type)) {
    console.error(props);
    throw new Error('Must have a valid type.');
  }

  if (!(0, _lang.isValidId)(props.id)) {
    console.error(props);
    throw new Error('Must have a valid id.');
  }

  if (typeId && props.type !== typeId) throw new Error('Wrong entity type.');
  return doPick ? pickTypeId(props) : null;
}

function getPath(item, fieldId) {
  requireIdType(item, null, false);
  var path = [item.type, item.id];
  if (fieldId) path.push(fieldId);
  return path;
}

function getRefPath(predicate, obj) {
  if (!(0, _isString3.default)(predicate)) throw new Error('predicate must be a string.');
  return !obj ? [REF, predicate] : [REFS, predicate, getKey(obj)];
}

function fullRefPath(subj, predicate, obj) {
  return getPath(subj).concat(getRefPath(predicate, obj));
}

function setRef(subject, predicate, obj) {
  return (0, _capeLodash.setIn)(getRefPath(predicate), subject, pickTypeId(obj));
}

function setRefs(subject, predicate, obj) {
  return (0, _capeLodash.setIn)(getRefPath(predicate, obj), subject, pickTypeId(obj));
}

function buildRef(result, val, predicate) {
  function setArrayRefs(subject, obj) {
    return (0, _capeLodash.setIn)(getRefPath(predicate, obj), subject, pickTypeId(obj));
  } // Does not support merging previously set REF field.


  if ((0, _isArray3.default)(val)) return (0, _reduce3.default)(val, setArrayRefs, result);
  if ((0, _lang.isEntityCreated)(val)) return setRef(result, predicate, val);
  return (0, _set3.default)(result, predicate, val);
} // Get predicate from an entity.


function getRef(node, predicate) {
  if (!(0, _isString3.default)(predicate)) throw new Error('getRef() predicate must be a string.');
  return (0, _get3.default)(node, [REF, predicate]);
}

var fpGetRef = exports.fpGetRef = (0, _curry3.default)((0, _rearg3.default)(getRef, [1, 0]), 2);

function getRefs(node, predicate) {
  return (0, _get3.default)(node, [REFS, predicate]);
} // First is the object you are looking for.


var refMatch = exports.refMatch = (0, _curry3.default)(function (ref, obj) {
  return obj && obj.id === ref.id && obj.type === ref.type;
});
var hasPredicate = exports.hasPredicate = (0, _curry3.default)(function (predicate, subject, node) {
  return refMatch(subject, getRef(node, predicate));
});
var predicateFilter = exports.predicateFilter = (0, _curry3.default)(function (predicate, obj, collection) {
  return (0, _pickBy3.default)(collection, hasPredicate(predicate, obj));
}); // Split out triple refs because the need to be handled in the reducer.

function buildRefs(entity) {
  return (0, _reduce3.default)(entity, buildRef, {});
}

var indexFields = exports.indexFields = (_indexFields = {
  rangeIncludes: {}
}, _defineProperty(_indexFields, REF, {}), _defineProperty(_indexFields, REFS, {}), _indexFields);
var rmRefs = exports.rmRefs = (0, _omit3.default)([REF, REFS]); // Add fields required for save.

function insertFields() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _extends({
    type: 'Thing'
  }, indexFields, buildRefs(data), {
    dateCreated: data.dateCreated ? data.dateCreated : (0, _now3.default)(),
    id: data.id ? data.id : nextId()
  });
}

function updateFields(data) {
  return _extends({}, buildRefs(data), {
    dateModified: data.dateModified ? data.dateModified : (0, _now3.default)()
  });
}

function uniqEntity(type) {
  return insertFields({
    type: type
  });
}

var tripleErr = exports.tripleErr = (0, _flow3.default)(_lang.getTripleError, function (errMsg) {
  if (errMsg) throw new Error(errMsg);
});

function isSingle(_ref2) {
  var single = _ref2.single,
      ref = _ref2.ref,
      multi = _ref2.multi;
  return single || ref || multi === false;
} // You may send it a full entity for subject and object.
// Predicate should be a text string.
// @see lang/getTripleError()


function buildTriple(triple) {
  tripleErr(triple);
  var result = {
    subject: pickTypeId(triple.subject),
    predicate: triple.predicate,
    object: pickTypeId(triple.object)
  };
  if (isSingle(triple)) result.single = true;
  return result;
}

function buildTripleDel(triple) {
  tripleErr(triple, false);
  var single = isSingle(triple) || !triple.object;
  var result = {
    subject: pickTypeId(triple.subject),
    predicate: triple.predicate,
    object: single ? null : pickTypeId(triple.object)
  };
  if (single) result.single = true;
  return result;
}

function rangePath(obj, predicate, subj, subjKey) {
  var key = subjKey || getKey(subj);
  return getPath(obj).concat(['rangeIncludes', predicate, key]);
}

function setRangeIncludes(prevState, obj, predicate, subj, subjKey) {
  return (0, _capeLodash.setIn)(rangePath(obj, predicate, subj, subjKey), prevState, subj);
}

function entityMatch(object, source) {
  if (!(0, _lang.isEntityCreated)(object) || !(0, _lang.isEntityCreated)(source)) return false;
  return object.id === source.id && object.type === source.type;
}

function entityMatches(source) {
  return (0, _ary3.default)((0, _partialRight3.default)(entityMatch, source), 1);
}